export default "/img/PN.55384e35e02655f3c146cccb814bc8a9.png";